unit Unit2;

interface

uses
  SysUtils, Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  WEBLib.Controls, WEBLib.StdCtrls, WEBLib.Grids, WEBLib.ExtCtrls, WEBLib.CDS, WEBLib.Buttons;

type
  TForm2 = class(TForm)
    WebImageControl1: TImageControl;
    WebComboBox1: TComboBox;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebComboBox2: TComboBox;
    WebLabel7: TLabel;
    WebImageControl2: TImageControl;
    WebEdit3: TEdit;
    WebEdit4: TEdit;
    WebLabel10: TLabel;
    WebEdit1: TEdit;
    WebEdit2: TEdit;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebEdit5: TEdit;
    WebLabel11: TLabel;
    WebLabel12: TLabel;
    WebEdit6: TEdit;
    WebLabel13: TLabel;
    WebEdit7: TEdit;
    WebEdit8: TEdit;
    WebButton1: TButton;
    WebLabel15: TLabel;
    procedure WebComboBox2Change(Sender: TObject);
    procedure WebComboBox1Change(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebEdit3Change(Sender: TObject);
    procedure WebEdit4Change(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
  private
    { Private declarations }
  protected
    procedure LoadDFMValues; override;
  public
    { Public declarations }
  end;

var
  Form2: TForm2;

implementation


uses ufrmMain, Unit1;

procedure TForm2.WebButton1Click(Sender: TObject);
begin
 ShowMessage('TO JEST = '+FrmMain.WebEdit12.Text);
end;

procedure TForm2.WebComboBox1Change(Sender: TObject);
var   DIC               : String;
      wart, W1, W2      : Real;
begin
wart:=0; W1:=0; W2:=0;
  case WebComboBox1.ItemIndex of
  0: begin DIC:='MP-P-280W.jpg'; WebEdit1.Text:='280'; WebEdit2.Text:=FloattoStr(280*StrtoFloat(WebEdit3.Text)); WebEdit7.Text:='500'; end;
  1: begin DIC:='MP-M-305W.jpg'; WebEdit1.Text:='305'; WebEdit2.Text:=FloattoStr(305*StrtoFloat(WebEdit3.Text)); WebEdit7.Text:='510'; end;
  2: begin DIC:='MP-M-310W.jpg'; WebEdit1.Text:='310'; WebEdit2.Text:=FloattoStr(310*StrtoFloat(WebEdit3.Text)); WebEdit7.Text:='520'; end;
  3: begin DIC:='MP-M-320W.jpg'; WebEdit1.Text:='320'; WebEdit2.Text:=FloattoStr(320*StrtoFloat(WebEdit3.Text)); WebEdit7.Text:='535'; end;
  4: begin DIC:='MP-M-325W.jpg'; WebEdit1.Text:='325'; WebEdit2.Text:=FloattoStr(325*StrtoFloat(WebEdit3.Text)); WebEdit7.Text:='550'; end;
  5: begin DIC:='MP-M-330W.jpg'; WebEdit1.Text:='330'; WebEdit2.Text:=FloattoStr(330*StrtoFloat(WebEdit3.Text)); WebEdit7.Text:='570'; end;
  6: begin DIC:='MP-M-335W.jpg'; WebEdit1.Text:='335'; WebEdit2.Text:=FloattoStr(335*StrtoFloat(WebEdit3.Text)); WebEdit7.Text:='580'; end;
  7: begin DIC:='MP-M-340W.jpg'; WebEdit1.Text:='340'; WebEdit2.Text:=FloattoStr(340*StrtoFloat(WebEdit3.Text)); WebEdit7.Text:='590'; end;
  8: begin DIC:='MP-M-350W.jpg'; WebEdit1.Text:='350'; WebEdit2.Text:=FloattoStr(350*StrtoFloat(WebEdit3.Text)); WebEdit7.Text:='600'; end;
  end;
  WebImageControl1.URL:='img\'+DIC;
   WebEdit2.Text:=FloattoStr(StrtoFloat(WebEdit1.Text)*StrtoFloat(WebEdit3.Text));
    wart:=wart+StrtoFloat(WebEdit3.Text)*StrtoFloat(WebEdit7.Text);
    wart:=wart+StrtoFloat(WebEdit4.Text)*StrtoFloat(WebEdit8.Text);
  wart:=wart+(StrtoFloat(FrmMain.WebEdit6.Text)*StrtoFloat(WebEdit2.Text)/1000);
// FrmMain.WebEdit5.Text:=FloattoStr(wart);
 FrmMain.WebEdit4.Text:=FloattoStr(StrtoFloat(FrmMain.WebEdit1.Text)*StrtoFloat(WebEdit2.Text)/1000);
  FrmMain.WebEdit12.Text:=WebComboBox1.Text;
  FrmMain.WebEdit10.Text:=WebEdit3.Text;
  FrmMain.WebEdit16.Text:=WebEdit1.Text;
  FrmMain.WebEdit18.Text:=WebEdit7.Text;
end;

procedure TForm2.WebComboBox2Change(Sender: TObject);
var   DIC               : String;
      wart              : Real;
begin
wart:=0;
  case WebComboBox2.ItemIndex of
  0: begin DIC:='G1000S.jpg';  WebEdit5.Text:='1000'; WebEdit6.Text:=FloattoStr(1000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='1880'; end;
  1: begin  DIC:='G2000S.jpg';  WebEdit5.Text:='2000'; WebEdit6.Text:=FloattoStr(2000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='2244'; end;
  2: begin  DIC:='G3000S.jpg';  WebEdit5.Text:='3000'; WebEdit6.Text:=FloattoStr(3000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='2607'; end;
  3: begin  DIC:='G2500MTLS.jpg';  WebEdit5.Text:='2500'; WebEdit6.Text:=FloattoStr(2500*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='2930'; end;
  4: begin  DIC:='G3000MTLS.jpg';  WebEdit5.Text:='3000'; WebEdit6.Text:=FloattoStr(3000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='3052'; end;
  5: begin  DIC:='G3600MTLS.jpg';  WebEdit5.Text:='3600'; WebEdit6.Text:=FloattoStr(3600*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='3233'; end;
  6: begin  DIC:='G4200MTLS.jpg';  WebEdit5.Text:='4200'; WebEdit6.Text:=FloattoStr(4200*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='3657'; end;
  7: begin  DIC:='G5000MTLS.jpg';  WebEdit5.Text:='5000'; WebEdit6.Text:=FloattoStr(5000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='3980'; end;
  8: begin  DIC:='G5500MTLS.jpg';  WebEdit5.Text:='5500'; WebEdit6.Text:=FloattoStr(5500*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='4175'; end;
  9: begin  DIC:='G3000TL3S.jpg';  WebEdit5.Text:='3000'; WebEdit6.Text:=FloattoStr(3000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='4031'; end;
  10: begin  DIC:='G4000TL3S.jpg';  WebEdit5.Text:='4000'; WebEdit6.Text:=FloattoStr(4000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='4147'; end;
  11: begin  DIC:='G5000TL3S.jpg';  WebEdit5.Text:='5000'; WebEdit6.Text:=FloattoStr(5000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='4612'; end;
  12: begin  DIC:='G6000TL3S.jpg';  WebEdit5.Text:='6000'; WebEdit6.Text:=FloattoStr(6000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='5048'; end;
  13: begin  DIC:='G7000TL3S.jpg';  WebEdit5.Text:='7000'; WebEdit6.Text:=FloattoStr(7000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='5995'; end;
  14: begin  DIC:='G8000TL3S.jpg';  WebEdit5.Text:='8000'; WebEdit6.Text:=FloattoStr(8000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='6068'; end;
  15: begin  DIC:='G9000TL3S.jpg';  WebEdit5.Text:='9000'; WebEdit6.Text:=FloattoStr(9000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='6286'; end;
  16: begin  DIC:='G10000TL3S.jpg';  WebEdit5.Text:='10000'; WebEdit6.Text:=FloattoStr(10000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='6232'; end;
  17: begin  DIC:='G11000TL3S.jpg';  WebEdit5.Text:='11000'; WebEdit6.Text:=FloattoStr(11000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='7506'; end;
  18: begin  DIC:='G12000TL3S.jpg';  WebEdit5.Text:='12000'; WebEdit6.Text:=FloattoStr(12000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='7943'; end;
  19: begin  DIC:='G13000TL3S.jpg';  WebEdit5.Text:='13000'; WebEdit6.Text:=FloattoStr(13000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='8135'; end;
  20: begin  DIC:='G15000TL3S.jpg';  WebEdit5.Text:='15000'; WebEdit6.Text:=FloattoStr(15000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='8571'; end;
  21: begin  DIC:='G17000TL3S.jpg';  WebEdit5.Text:='17000'; WebEdit6.Text:=FloattoStr(17000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='8816'; end;
  22: begin  DIC:='G20000TL3S.jpg';  WebEdit5.Text:='20000'; WebEdit6.Text:=FloattoStr(20000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='9181'; end;
  23: begin  DIC:='G25000TL3S.jpg';  WebEdit5.Text:='25000'; WebEdit6.Text:=FloattoStr(25000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='10634'; end;
  24: begin  DIC:='G30000TL3S.jpg';  WebEdit5.Text:='30000'; WebEdit6.Text:=FloattoStr(30000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='12158'; end;
  25: begin  DIC:='G33000TL3S.jpg';  WebEdit5.Text:='33000'; WebEdit6.Text:=FloattoStr(33000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='12495'; end;
  26: begin  DIC:='G40000TL3S.jpg';  WebEdit5.Text:='40000'; WebEdit6.Text:=FloattoStr(40000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='13723'; end;
  27: begin  DIC:='G50KMAX.jpg';  WebEdit5.Text:='50000'; WebEdit6.Text:=FloattoStr(50000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='15680'; end;
  28: begin  DIC:='G60KMAX.jpg';  WebEdit5.Text:='60000'; WebEdit6.Text:=FloattoStr(60000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='17300'; end;
  29: begin  DIC:='G70KMAX.jpg';  WebEdit5.Text:='70000'; WebEdit6.Text:=FloattoStr(70000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='19661'; end;
  30: begin  DIC:='G80KMAX.jpg';  WebEdit5.Text:='80000'; WebEdit6.Text:=FloattoStr(80000*StrtoFloat(WebEdit4.Text)); WebEdit8.Text:='21281'; end;
  end;
  WebImageControl2.URL:='img\'+DIC;
   WebEdit6.Text:=FloattoStr(StrtoFloat(WebEdit5.Text)*StrtoFloat(WebEdit4.Text));
   wart:=wart+StrtoFloat(WebEdit3.Text)*StrtoFloat(WebEdit7.Text);
    wart:=wart+StrtoFloat(WebEdit4.Text)*StrtoFloat(WebEdit8.Text);
  wart:=wart+(StrtoFloat(FrmMain.WebEdit6.Text)*StrtoFloat(WebEdit2.Text)/1000);
// FrmMain.WebEdit5.Text:=FloattoStr(wart);
 FrmMain.WebEdit13.Text:=WebComboBox2.Text;
  FrmMain.WebEdit11.Text:=WebEdit4.Text;
  FrmMain.WebEdit17.Text:=WebEdit5.Text;
   FrmMain.WebEdit19.Text:=WebEdit8.Text;
  end;

procedure TForm2.WebEdit3Change(Sender: TObject);
var   DIC               : String;
begin
  case WebComboBox1.ItemIndex of
  0: begin DIC:='MP-P-280W.jpg'; WebEdit1.Text:='280'; WebEdit2.Text:=FloattoStr(280*StrtoFloat(WebEdit3.Text)); end;
  1: begin DIC:='MP-M-305W.jpg'; WebEdit1.Text:='305'; WebEdit2.Text:=FloattoStr(305*StrtoFloat(WebEdit3.Text)); end;
  2: begin DIC:='MP-M-310W.jpg'; WebEdit1.Text:='310'; WebEdit2.Text:=FloattoStr(310*StrtoFloat(WebEdit3.Text)); end;
  3: begin DIC:='MP-M-320W.jpg'; WebEdit1.Text:='320'; WebEdit2.Text:=FloattoStr(320*StrtoFloat(WebEdit3.Text)); end;
  4: begin DIC:='MP-M-325W.jpg'; WebEdit1.Text:='325'; WebEdit2.Text:=FloattoStr(325*StrtoFloat(WebEdit3.Text)); end;
  5: begin DIC:='MP-M-330W.jpg'; WebEdit1.Text:='330'; WebEdit2.Text:=FloattoStr(330*StrtoFloat(WebEdit3.Text)); end;
  6: begin DIC:='MP-M-335W.jpg'; WebEdit1.Text:='335'; WebEdit2.Text:=FloattoStr(335*StrtoFloat(WebEdit3.Text)); end;
  7: begin DIC:='MP-M-340W.jpg'; WebEdit1.Text:='340'; WebEdit2.Text:=FloattoStr(340*StrtoFloat(WebEdit3.Text)); end;
  8: begin DIC:='MP-M-350W.jpg'; WebEdit1.Text:='350'; WebEdit2.Text:=FloattoStr(350*StrtoFloat(WebEdit3.Text)); end;
  end;
  WebImageControl1.URL:='img\'+DIC;
end;

procedure TForm2.WebEdit4Change(Sender: TObject);
var   DIC               : String;
begin
  case WebComboBox2.ItemIndex of
  0: begin DIC:='G1000S.jpg';  WebEdit5.Text:='1000'; WebEdit6.Text:=FloattoStr(1000*StrtoFloat(WebEdit4.Text)); end;
  1: begin  DIC:='G2000S.jpg';  WebEdit5.Text:='2000'; WebEdit6.Text:=FloattoStr(2000*StrtoFloat(WebEdit4.Text)); end;
  2: begin  DIC:='G3000S.jpg';  WebEdit5.Text:='3000'; WebEdit6.Text:=FloattoStr(3000*StrtoFloat(WebEdit4.Text)); end;
  3: begin  DIC:='G2500MTLS.jpg';  WebEdit5.Text:='2500'; WebEdit6.Text:=FloattoStr(2500*StrtoFloat(WebEdit4.Text)); end;
  4: begin  DIC:='G3000MTLS.jpg';  WebEdit5.Text:='3000'; WebEdit6.Text:=FloattoStr(3000*StrtoFloat(WebEdit4.Text)); end;
  5: begin  DIC:='G3600MTLS.jpg';  WebEdit5.Text:='3600'; WebEdit6.Text:=FloattoStr(3600*StrtoFloat(WebEdit4.Text)); end;
  6: begin  DIC:='G4200MTLS.jpg';  WebEdit5.Text:='4200'; WebEdit6.Text:=FloattoStr(4200*StrtoFloat(WebEdit4.Text)); end;
  7: begin  DIC:='G5000MTLS.jpg';  WebEdit5.Text:='5000'; WebEdit6.Text:=FloattoStr(5000*StrtoFloat(WebEdit4.Text)); end;
  8: begin  DIC:='G5500MTLS.jpg';  WebEdit5.Text:='5500'; WebEdit6.Text:=FloattoStr(5500*StrtoFloat(WebEdit4.Text)); end;
  9: begin  DIC:='G3000TL3S.jpg';  WebEdit5.Text:='3000'; WebEdit6.Text:=FloattoStr(3000*StrtoFloat(WebEdit4.Text)); end;
  10: begin  DIC:='G4000TL3S.jpg';  WebEdit5.Text:='4000'; WebEdit6.Text:=FloattoStr(4000*StrtoFloat(WebEdit4.Text)); end;
  11: begin  DIC:='G5000TL3S.jpg';  WebEdit5.Text:='5000'; WebEdit6.Text:=FloattoStr(5000*StrtoFloat(WebEdit4.Text)); end;
  12: begin  DIC:='G6000TL3S.jpg';  WebEdit5.Text:='6000'; WebEdit6.Text:=FloattoStr(6000*StrtoFloat(WebEdit4.Text)); end;
  13: begin  DIC:='G7000TL3S.jpg';  WebEdit5.Text:='7000'; WebEdit6.Text:=FloattoStr(7000*StrtoFloat(WebEdit4.Text)); end;
  14: begin  DIC:='G8000TL3S.jpg';  WebEdit5.Text:='8000'; WebEdit6.Text:=FloattoStr(8000*StrtoFloat(WebEdit4.Text)); end;
  15: begin  DIC:='G9000TL3S.jpg';  WebEdit5.Text:='9000'; WebEdit6.Text:=FloattoStr(9000*StrtoFloat(WebEdit4.Text)); end;
  16: begin  DIC:='G10000TL3S.jpg';  WebEdit5.Text:='10000'; WebEdit6.Text:=FloattoStr(10000*StrtoFloat(WebEdit4.Text)); end;
  17: begin  DIC:='G11000TL3S.jpg';  WebEdit5.Text:='11000'; WebEdit6.Text:=FloattoStr(11000*StrtoFloat(WebEdit4.Text)); end;
  18: begin  DIC:='G12000TL3S.jpg';  WebEdit5.Text:='12000'; WebEdit6.Text:=FloattoStr(12000*StrtoFloat(WebEdit4.Text)); end;
  19: begin  DIC:='G13000TL3S.jpg';  WebEdit5.Text:='13000'; WebEdit6.Text:=FloattoStr(13000*StrtoFloat(WebEdit4.Text)); end;
  20: begin  DIC:='G15000TL3S.jpg';  WebEdit5.Text:='15000'; WebEdit6.Text:=FloattoStr(15000*StrtoFloat(WebEdit4.Text)); end;
  21: begin  DIC:='G17000TL3S.jpg';  WebEdit5.Text:='17000'; WebEdit6.Text:=FloattoStr(17000*StrtoFloat(WebEdit4.Text)); end;
  22: begin  DIC:='G20000TL3S.jpg';  WebEdit5.Text:='20000'; WebEdit6.Text:=FloattoStr(20000*StrtoFloat(WebEdit4.Text)); end;
  23: begin  DIC:='G25000TL3S.jpg';  WebEdit5.Text:='25000'; WebEdit6.Text:=FloattoStr(25000*StrtoFloat(WebEdit4.Text)); end;
  24: begin  DIC:='G30000TL3S.jpg';  WebEdit5.Text:='30000'; WebEdit6.Text:=FloattoStr(30000*StrtoFloat(WebEdit4.Text)); end;
  25: begin  DIC:='G33000TL3S.jpg';  WebEdit5.Text:='33000'; WebEdit6.Text:=FloattoStr(33000*StrtoFloat(WebEdit4.Text)); end;
  26: begin  DIC:='G40000TL3S.jpg';  WebEdit5.Text:='40000'; WebEdit6.Text:=FloattoStr(40000*StrtoFloat(WebEdit4.Text)); end;
  27: begin  DIC:='G50KMAX.jpg';  WebEdit5.Text:='50000'; WebEdit6.Text:=FloattoStr(50000*StrtoFloat(WebEdit4.Text)); end;
  28: begin  DIC:='G60KMAX.jpg';  WebEdit5.Text:='60000'; WebEdit6.Text:=FloattoStr(60000*StrtoFloat(WebEdit4.Text)); end;
  29: begin  DIC:='G70KMAX.jpg';  WebEdit5.Text:='70000'; WebEdit6.Text:=FloattoStr(70000*StrtoFloat(WebEdit4.Text)); end;
  30: begin  DIC:='G80KMAX.jpg';  WebEdit5.Text:='80000'; WebEdit6.Text:=FloattoStr(80000*StrtoFloat(WebEdit4.Text)); end;
  end;
  WebImageControl2.URL:='img\'+DIC;
end;

procedure TForm2.WebFormCreate(Sender: TObject);
var   DIC               : String;
      PW, wart                : Real;
begin
  DIC:='MP-P-280W.jpg';
  WebComboBox1.ItemIndex:=0;
  WebImageControl1.URL:='img\'+DIC;

  DIC:='G1000S.jpg';
  WebComboBox2.ItemIndex:=0;
  WebImageControl2.URL:='img\'+DIC;

  PW:=Round(StrtoFloat(FrmMain.WebEdit7.Text)/(StrtoFloat(WebEdit1.Text)/1000));
  WebEdit3.Text:=FloattoStr(PW);
  WebEdit2.Text:=FloattoStr(StrtoFloat(WebEdit3.Text)*StrtoFloat(WebEdit1.Text));
   WebEdit2.Text:=FloattoStr(StrtoFloat(WebEdit1.Text)*StrtoFloat(WebEdit3.Text));
    wart:=wart+StrtoFloat(WebEdit3.Text)*StrtoFloat(WebEdit7.Text);
    wart:=wart+StrtoFloat(WebEdit4.Text)*StrtoFloat(WebEdit8.Text);
  wart:=wart+(StrtoFloat(FrmMain.WebEdit6.Text)*StrtoFloat(WebEdit2.Text)/1000);
 FrmMain.WebEdit5.Text:=FloattoStr(wart);
 FrmMain.WebEdit4.Text:=FloattoStr(StrtoFloat(FrmMain.WebEdit1.Text)*StrtoFloat(WebEdit2.Text)/1000);
  FrmMain.WebEdit12.Text:=WebComboBox1.Text;
  FrmMain.WebEdit10.Text:=WebEdit3.Text;
  FrmMain.WebEdit16.Text:=WebEdit1.Text;
  FrmMain.WebEdit18.Text:=WebEdit7.Text;
   WebEdit6.Text:=FloattoStr(StrtoFloat(WebEdit5.Text)*StrtoFloat(WebEdit4.Text));
   wart:=wart+StrtoFloat(WebEdit3.Text)*StrtoFloat(WebEdit7.Text);
    wart:=wart+StrtoFloat(WebEdit4.Text)*StrtoFloat(WebEdit8.Text);
  wart:=wart+(StrtoFloat(FrmMain.WebEdit6.Text)*StrtoFloat(WebEdit2.Text)/1000);
 FrmMain.WebEdit5.Text:=FloattoStr(wart);
 FrmMain.WebEdit13.Text:=WebComboBox2.Text;
  FrmMain.WebEdit11.Text:=WebEdit4.Text;
  FrmMain.WebEdit17.Text:=WebEdit5.Text;
   FrmMain.WebEdit19.Text:=WebEdit8.Text;
end;

procedure TForm2.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebImageControl1 := TImageControl.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebImageControl2 := TImageControl.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebComboBox1 := TComboBox.Create(Self);
  WebComboBox2 := TComboBox.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebEdit4 := TEdit.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebEdit5 := TEdit.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebEdit7 := TEdit.Create(Self);
  WebEdit8 := TEdit.Create(Self);
  WebButton1 := TButton.Create(Self);

  WebImageControl1.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebImageControl2.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebComboBox1.BeforeLoadDFMValues;
  WebComboBox2.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebEdit5.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  WebEdit8.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  try
    Name := 'Form2';
    Left := 0;
    Top := 0;
    Width := 640;
    Height := 450;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, Self, 'OnCreate', 'WebFormCreate');
    WebImageControl1.SetParentComponent(Self);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 13;
    WebImageControl1.Top := 170;
    WebImageControl1.Width := 273;
    WebImageControl1.Height := 153;
    WebImageControl1.ChildOrder := 1;
    WebLabel4.SetParentComponent(Self);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 10;
    WebLabel4.Top := 119;
    WebLabel4.Width := 56;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Typ modu'#322'u';
    WebLabel5.SetParentComponent(Self);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 10;
    WebLabel5.Top := 149;
    WebLabel5.Width := 68;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'Ilo'#347#263' modu'#322#243'w';
    WebLabel6.SetParentComponent(Self);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 340;
    WebLabel6.Top := 119;
    WebLabel6.Width := 67;
    WebLabel6.Height := 13;
    WebLabel6.Caption := 'Typ inwertera';
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 340;
    WebLabel7.Top := 149;
    WebLabel7.Width := 79;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Ilo'#347#263' inwerter'#243'w';
    WebImageControl2.SetParentComponent(Self);
    WebImageControl2.Name := 'WebImageControl2';
    WebImageControl2.Left := 343;
    WebImageControl2.Top := 167;
    WebImageControl2.Width := 279;
    WebImageControl2.Height := 199;
    WebImageControl2.ChildOrder := 1;
    WebLabel10.SetParentComponent(Self);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 13;
    WebLabel10.Top := 85;
    WebLabel10.Width := 205;
    WebLabel10.Height := 16;
    WebLabel10.Caption := 'Dane instalacji fotowoltaiccznej';
    WebLabel10.Font.Charset := DEFAULT_CHARSET;
    WebLabel10.Font.Color := clMenuHighlight;
    WebLabel10.Font.Height := 16;
    WebLabel10.Font.Name := 'Tahoma';
    WebLabel10.Font.Style := [fsBold];
    WebLabel10.ParentFont := False;
    WebLabel10.Transparent := False;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 13;
    WebLabel1.Top := 380;
    WebLabel1.Width := 57;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Moc modu'#322'u';
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 161;
    WebLabel2.Top := 380;
    WebLabel2.Width := 16;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Wp';
    WebLabel3.SetParentComponent(Self);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 13;
    WebLabel3.Top := 404;
    WebLabel3.Width := 63;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'Moc instalacji';
    WebLabel8.SetParentComponent(Self);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 161;
    WebLabel8.Top := 404;
    WebLabel8.Width := 16;
    WebLabel8.Height := 13;
    WebLabel8.Caption := 'Wp';
    WebLabel9.SetParentComponent(Self);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 349;
    WebLabel9.Top := 380;
    WebLabel9.Width := 67;
    WebLabel9.Height := 13;
    WebLabel9.Caption := 'Moc falownika';
    WebLabel11.SetParentComponent(Self);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 544;
    WebLabel11.Top := 380;
    WebLabel11.Width := 10;
    WebLabel11.Height := 13;
    WebLabel11.Caption := 'W';
    WebLabel12.SetParentComponent(Self);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 351;
    WebLabel12.Top := 404;
    WebLabel12.Width := 113;
    WebLabel12.Height := 13;
    WebLabel12.Caption := 'Moc instalacji /falownik/';
    WebLabel13.SetParentComponent(Self);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 544;
    WebLabel13.Top := 404;
    WebLabel13.Width := 10;
    WebLabel13.Height := 13;
    WebLabel13.Caption := 'W';
    WebLabel15.SetParentComponent(Self);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 13;
    WebLabel15.Top := 426;
    WebLabel15.Width := 211;
    WebLabel15.Height := 13;
    WebLabel15.Caption := 'Kalkulator fotowoltaiczny - Pro-Sun (c) 2020';
    WebLabel15.Color := clYellow;
    WebLabel15.Transparent := False;
    WebComboBox1.SetParentComponent(Self);
    WebComboBox1.Name := 'WebComboBox1';
    WebComboBox1.Left := 97;
    WebComboBox1.Top := 116;
    WebComboBox1.Width := 189;
    WebComboBox1.Height := 22;
    WebComboBox1.Color := clInfoBk;
    WebComboBox1.Text := 'MODU'#321' FOTOWOLTAICZNY MP-P-280W';
    SetEvent(WebComboBox1, Self, 'OnChange', 'WebComboBox1Change');
    WebComboBox1.ItemIndex := 0;
    WebComboBox1.Items.BeginUpdate;
    try
      WebComboBox1.Items.Clear;
      WebComboBox1.Items.Add('MODU'#321' FOTOWOLTAICZNY MP-P-280W');
      WebComboBox1.Items.Add('MODU'#321' FOTOWOLTAICZNY MP-M-305W');
      WebComboBox1.Items.Add('MODU'#321' FOTOWOLTAICZNY MP-M-310W');
      WebComboBox1.Items.Add('MODU'#321' FOTOWOLTAICZNY MP-M-320W');
      WebComboBox1.Items.Add('MODU'#321' FOTOWOLTAICZNY MP-M-325W');
      WebComboBox1.Items.Add('MODU'#321' FOTOWOLTAICZNY MP-M-330W');
      WebComboBox1.Items.Add('MODU'#321' FOTOWOLTAICZNY MP-M-335W');
      WebComboBox1.Items.Add('MODU'#321' FOTOWOLTAICZNY MP-M-340W');
      WebComboBox1.Items.Add('MODU'#321' FOTOWOLTAICZNY MP-M-350W');
    finally
      WebComboBox1.Items.EndUpdate;
    end;
    WebComboBox2.SetParentComponent(Self);
    WebComboBox2.Name := 'WebComboBox2';
    WebComboBox2.Left := 427;
    WebComboBox2.Top := 116;
    WebComboBox2.Width := 195;
    WebComboBox2.Height := 22;
    WebComboBox2.Color := clInfoBk;
    WebComboBox2.Text := 'GROWATT 1000 S';
    SetEvent(WebComboBox2, Self, 'OnChange', 'WebComboBox2Change');
    WebComboBox2.ItemIndex := 0;
    WebComboBox2.Items.BeginUpdate;
    try
      WebComboBox2.Items.Clear;
      WebComboBox2.Items.Add('GROWATT 1000 S');
      WebComboBox2.Items.Add('GROWATT 2000 S');
      WebComboBox2.Items.Add('GROWATT 3000 S');
      WebComboBox2.Items.Add('GROWATT 2500 MTL-S');
      WebComboBox2.Items.Add('GROWATT 3000 MTL-S');
      WebComboBox2.Items.Add('GROWATT 3600 MTL-S');
      WebComboBox2.Items.Add('GROWATT 4200 MTL-S');
      WebComboBox2.Items.Add('GROWATT 5000 MTL-S');
      WebComboBox2.Items.Add('GROWATT 5500 MTL S');
      WebComboBox2.Items.Add('GROWATT 3000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 4000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 5000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 6000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 7000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 8000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 9000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 10000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 11000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 12000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 13000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 15000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 17000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 20000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 25000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 30000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 33000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 40000 TL3-S');
      WebComboBox2.Items.Add('GROWATT 50 K MAX');
      WebComboBox2.Items.Add('GROWATT 60 K MAX');
      WebComboBox2.Items.Add('GROWATT 70 K MAX');
      WebComboBox2.Items.Add('GROWATT 80 K MAX');
    finally
      WebComboBox2.Items.EndUpdate;
    end;
    WebEdit3.SetParentComponent(Self);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 97;
    WebEdit3.Top := 144;
    WebEdit3.Width := 37;
    WebEdit3.Height := 19;
    WebEdit3.ChildOrder := 18;
    WebEdit3.Color := clInfoBk;
    WebEdit3.Text := '1';
    SetEvent(WebEdit3, Self, 'OnChange', 'WebEdit3Change');
    WebEdit4.SetParentComponent(Self);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 425;
    WebEdit4.Top := 142;
    WebEdit4.Width := 47;
    WebEdit4.Height := 19;
    WebEdit4.ChildOrder := 19;
    WebEdit4.Color := clInfoBk;
    WebEdit4.Text := '1';
    SetEvent(WebEdit4, Self, 'OnChange', 'WebEdit4Change');
    WebEdit1.SetParentComponent(Self);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 97;
    WebEdit1.Top := 377;
    WebEdit1.Width := 57;
    WebEdit1.Height := 19;
    WebEdit1.ChildOrder := 11;
    WebEdit1.Color := 16777200;
    WebEdit1.Enabled := False;
    WebEdit1.Text := '280';
    WebEdit2.SetParentComponent(Self);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 97;
    WebEdit2.Top := 401;
    WebEdit2.Width := 57;
    WebEdit2.Height := 19;
    WebEdit2.ChildOrder := 12;
    WebEdit2.Color := 16777200;
    WebEdit2.Enabled := False;
    WebEdit2.Text := '0';
    WebEdit5.SetParentComponent(Self);
    WebEdit5.Name := 'WebEdit5';
    WebEdit5.Left := 475;
    WebEdit5.Top := 377;
    WebEdit5.Width := 59;
    WebEdit5.Height := 19;
    WebEdit5.ChildOrder := 18;
    WebEdit5.Color := 16777200;
    WebEdit5.Enabled := False;
    WebEdit5.Text := '1000';
    WebEdit6.SetParentComponent(Self);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 475;
    WebEdit6.Top := 401;
    WebEdit6.Width := 59;
    WebEdit6.Height := 19;
    WebEdit6.ChildOrder := 21;
    WebEdit6.Color := 16777200;
    WebEdit6.Enabled := False;
    WebEdit6.Text := '0';
    WebEdit7.SetParentComponent(Self);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 221;
    WebEdit7.Top := 144;
    WebEdit7.Width := 65;
    WebEdit7.Height := 19;
    WebEdit7.ChildOrder := 23;
    WebEdit7.Text := '500';
    WebEdit7.Visible := False;
    WebEdit8.SetParentComponent(Self);
    WebEdit8.Name := 'WebEdit8';
    WebEdit8.Left := 557;
    WebEdit8.Top := 142;
    WebEdit8.Width := 65;
    WebEdit8.Height := 19;
    WebEdit8.ChildOrder := 24;
    WebEdit8.Text := '1880';
    WebEdit8.Visible := False;
    WebButton1.SetParentComponent(Self);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 255;
    WebButton1.Top := 414;
    WebButton1.Width := 55;
    WebButton1.Height := 25;
    WebButton1.Caption := 'WebButton1';
    WebButton1.ChildOrder := 25;
    WebButton1.Visible := False;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
  finally
    WebImageControl1.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebImageControl2.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebComboBox1.AfterLoadDFMValues;
    WebComboBox2.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebEdit5.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
    WebEdit8.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
  end;
end;

end.
